<template>
  <div id="app" v-loading.fullscreen.lock="fullscreenLoading" element-loading-background="rgba(255, 255, 255, 0)">
    <router-view v-if="isRouterAlive"/>
  </div>
</template>

<script>
import newVue from 'common/js/newVue'
export default {
  data() {
    return {
      fullscreenLoading: false,
      isRouterAlive: true
    }
  },
  name: 'app',
  provide() {
    return {
      reload: this.reload
    }
  },
  methods: {
    reload() {
      this.isRouterAlive = false
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
    }
  },
  created() {
    newVue.$on('toggleLoading', (show) => {
      this.fullscreenLoading = show
    })
  }
}
</script>

<style lang="scss">
  @import "~common/scss/reset";
  .myClass .el-submenu__icon-arrow .el-icon-arrow-down{
    color: #333 !important;
    display: none!important;
  }
  .pagination-wapper{
    z-index: 100;
    margin-top: 20px;
    padding: 15px 0 30px 0;
    background: #fff;
    position: relative;
  }
  .pagination-wapper{
    padding:0px !important;
    margin-top: 15px !important;
  }
  .table-wrapper {
    height: -webkit-calc(100% - (88px)) !important;
    height: -moz-calc(100% - (88px)) !important;
    height: calc(100% - (88px)) !important;
  }
  .main-wrapper{
    border: 1px solid #dce6e1;
    background-color: #ffffff;
    margin-top: 0px !important;
    padding: 15px 15px;
    height: calc(100% - (86px)) !important;
  }
  .myClass .el-icon-arrow-down::before{
    color: #333!important;
    display: none!important;
  }
  #app{
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    height:100%;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue